import './BodyNav.css';

const BodyNav = () => {
  return null;
};

export default BodyNav;

